import { ReviewPostEntryDetailPresenter } from '@/presentation/presenters/reviewPost/reviewPostEntryDetailPresenter'
import { ReviewPostEntryDetailViewModel } from '@/presentation/viewmodels/reviewPost/reviewPostEntryDetailViewModel'

export function useReviewPostEntryDetailPresenter(
  presenter: ReviewPostEntryDetailPresenter = new ReviewPostEntryDetailPresenter(new ReviewPostEntryDetailViewModel())
) {
  return {
    reviewEntryDetailList: presenter.reviewEntryDetailList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    fetchReviewEntryDetailList: presenter.fetchReviewEntryDetailList.bind(presenter),
    hasEntryDetailInList: presenter.hasEntryDetailInList.bind(presenter)
  }
}
